const trains = {
  train: "Trem", // translated
  trains: "Trens", // translated
  fairConditions: "Condições justas", // translated
  to: "para", // translated
  earlier: "Mais cedo", // translated
  later: "Mais tarde", // translated
  adults: "Adultos", // translated
  child: "Criança", // translated
  senior: "Senior", // translated
  seniors: "Idosos", // translated
  price: "Preço", // translated
  for: "para", // translated
  total: "Total", // translated
  selected: "Selecionado", // translated
  prebook: "Pré-reserva", // translated
  book: "Livro", // translated
  payment: "Pagamento", // translated
  return: "Retornar", // translated
  passengers: "Passageiros", // translated
  delivery: "Entrega", // translated
  summary: "Resumo", // translated
  checkout: "Confira", // translated
  trainToastCorrectFillForm: "Por favor preencha corretamente todos os campos.", // translated
  fareConditions: "Condições tarifárias", // translated
  travelInfo: "Informações de viagem", // translated
  remarks: "Observações do cliente", // translated
  noServices: "Sem serviços", // translated
  timesAndSeats: "Horários e assentos", // translated
  mobileTicket: "Bilhete móvel", // translated
  stationTicket: "Recolha na estação", // translated
  homeTicket: "Imprima em casa", // translated
  countryCode: "Código do país", // translated
  chooseTicket: "Escolha o método de entrega do ingresso", // translated
  ticketError: "Selecione um bilhete para todos os destinos", // translated
  ticketDelivery: "Selecione um método de entrega de ingressos", // translated
  passengerDetails: "Detalhes do passageiro", // translated
  waitWhileProcessingPayment: "Aguarde enquanto processamos seu pagamento, não atualize nem feche a página.", // translated
  reductionCardId: "ID do cartão de redução", // translated
  countryOfResidence: "País de Residência", // translated
  countryOfBirth: "País de nascimento", // translated
  documentCountry: "País do documento", // translated
  documentNumber: "Número do documento", // translated
  expirationDate: "Data de validade", // translated
  documentType: "Tipo de documento", // translated
  travelerDocumentInfo: "Informações do documento do viajante", // translated
  youth: "Juventude", // translated
  youths: "Jovens", // translated
  departTimeEarlyFirst: "Horário de partida (o mais cedo primeiro)", // translated
};


export default trains;
